module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/pavia.591d49c1f080498598eccaaaeb948d26.jpg";